export const GET_ACTIVE_REQUIRED_DOCUMENTS_SUCCESS = 'GET_ACTIVE_REQUIRED_DOCUMENTS_SUCCESS';
export const GET_ACTIVE_REQUIRED_DOCUMENTS_FAIL = 'GET_ACTIVE_REQUIRED_DOCUMENTS_FAIL';

export const GET_REQUIRED_DOCUMENTS_HISTORY_SUCCESS = 'GET_REQUIRED_DOCUMENTS_HISTORY_SUCCESS';
export const GET_REQUIRED_DOCUMENTS_HISTORY_FAIL = 'GET_REQUIRED_DOCUMENTS_HISTORY_FAIL';
